module.exports = __webpack_public_path__ + "img/cirLight_1.b6eeb1dc.png";